__turbopack_context__.v({
  "page": "monthly-update-module__4Wtcya__page",
});
